import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '@/views/Home.vue';
import About from '@/views/About.vue';
import a from '@/views/A.vue';
import b from '@/views/B.vue';
import c from '@/views/C.vue';
import d from '@/views/D.vue';
import e from '@/views/E.vue';
import f from '@/views/F.vue';
import g from '@/views/G.vue';
import h from '@/views/H.vue';
import i from '@/views/I.vue';
import j from '@/views/J.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  { path: '/', name: 'home', component: Home },
  { path: '/about', name: 'about', component: About },
  { path: '/a', name: 'a', component: a },
  { path: '/b', name: 'b', component: b },
  { path: '/c', name: 'c', component: c },
  { path: '/d', name: 'd', component: d },
  { path: '/e', name: 'e', component: e },
  { path: '/f', name: 'f', component: f },
  { path: '/g', name: 'g', component: g },
  { path: '/h', name: 'h', component: h },
  { path: '/i', name: 'i', component: i },
  { path: '/j', name: 'j', component: j }
];

const router = new VueRouter({
  routes
});

export default router;
